import React from 'react'
import { useStyles } from './style'
import illustrationSvg from '../../layouts/illustration.svg'

const Illustration = ({ size }) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <img
        src={illustrationSvg}
        alt='Illustration'
        className={classes.illustration}
        style={{ width: size }}
      />
    </div>
  )
}

export default Illustration
